module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_info_purple-a6ac8d61b9f867e933c4dd4ba99a67f5.svg";